var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-container", [
        _c(
          "div",
          { staticClass: "page-tournaments" },
          [
            _c("div", { staticClass: "page-tournaments__title" }, [
              _c("i", { staticClass: "icon" }),
              _c("div", { staticClass: "text" }, [
                _c("h2", [
                  _vm._v(_vm._s(_vm.$t("front.tournament.page.title")))
                ]),
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("front.tournament.page.description")))
                ])
              ])
            ]),
            _vm.isMobile
              ? _c("div", { staticClass: "page-tournaments__navTabs" }, [
                  _c("div", { staticClass: "navTabs" }, [
                    _c(
                      "div",
                      {
                        staticClass: "navTabs__item",
                        class: { active: _vm.activeTab === "live" },
                        on: {
                          click: function($event) {
                            _vm.activeTab = "live"
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("front.tournament.tabs.live")) +
                            "\n                    "
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "navTabs__item",
                        class: { active: _vm.activeTab === "upcoming" },
                        on: {
                          click: function($event) {
                            _vm.activeTab = "upcoming"
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("front.tournament.tabs.upcoming")) +
                            "\n                    "
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "navTabs__item",
                        class: { active: _vm.activeTab === "finished" },
                        on: {
                          click: function($event) {
                            _vm.activeTab = "finished"
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("front.tournament.tabs.ended")) +
                            "\n                    "
                        )
                      ]
                    )
                  ])
                ])
              : _vm._e(),
            _vm.active
              ? _c("tournament-part", {
                  attrs: {
                    reference: "live",
                    active: _vm.activeTab,
                    items: _vm.active,
                    priority: _vm.activePriority,
                    delay: _vm.activeDelay
                  }
                })
              : _vm._e(),
            _vm.showNewsSlider
              ? _c("tag-news-slider", {
                  attrs: {
                    newsTags: ["tournaments"],
                    title: _vm.$t("front.news.slider.tournament_title"),
                    hideSeeAllButton: true
                  }
                })
              : _vm._e(),
            _vm.pending
              ? _c("tournament-part", {
                  attrs: {
                    reference: "upcoming",
                    active: _vm.activeTab,
                    items: _vm.pending,
                    priority: _vm.pendingPriority,
                    delay: _vm.pendingDelay
                  }
                })
              : _vm._e(),
            _vm.awarded
              ? _c("tournament-part", {
                  attrs: {
                    reference: "finished",
                    active: _vm.activeTab,
                    items: _vm.awarded,
                    priority: _vm.awardedPriority,
                    delay: _vm.awardedDelay
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }